<template>
  <div class="main-navbar row" style="text-align: center">
    <div class="col-6 col-sm-12">
      <main-navbar-button
        title="Dashboard"
        route="/dashboard"
        icon="dashboard"
      ></main-navbar-button>
    </div>
    <div
      v-if="
        getApplicationSetting('ipad_planning') === '1' &&
        isAuthorized('planning', 'planning', 'view')
      "
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Planning"
        route="/planning"
        icon="planning"
      ></main-navbar-button>
    </div>
    <div
      v-if="
        isAuthorized('administration', 'transfer-notes', 'view') ||
        isAuthorized('administration', 'news', 'view') ||
        isAuthorized('administration', 'personal-documents', 'view') ||
        isAuthorized('administration', 'general-documents', 'view') ||
        isAuthorized('administration', 'person-register', 'view') ||
        isAuthorized('administration', 'employee-planning', 'view') ||
        isAuthorized('administration', 'child-planning-mutations', 'view') ||
        isAuthorized('administration', 'daycareRequest', 'view') ||
        isAuthorized('gastouder', 'qualifications', 'view') ||
        isAuthorized('gastouder', 'documents', 'view') ||
        isAuthorized('gastouder', 'payout-details', 'view') ||
        isAuthorized('gastouder', 'agreements', 'view') ||
        isAuthorized('gastouder', 'correspondence', 'view') ||
        isAuthorized('gastouder', 'benefit-overview', 'view') ||
        isAuthorized('gastouder', 'annual-statement', 'view')
      "
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Administratie"
        :route="routeUrl()"
        icon="transfer"
      ></main-navbar-button>
    </div>
    <div
      v-if="isAuthorized('communication', 'activities', 'view')"
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Logboek"
        route="/activities"
        icon="activities"
      ></main-navbar-button>
    </div>
    <div
      v-if="isAuthorized('communication', 'messages', 'view')"
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Berichten"
        :badge="hasUnreadChatMessages"
        route="/chat"
        icon="chat"
      ></main-navbar-button>
    </div>
    <div
      v-if="isAuthorized('communication', 'photos', 'view')"
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Foto's"
        :route="routePhoto()"
        icon="photos"
      ></main-navbar-button>
    </div>
    <div
      v-if="isAuthorized('instructions', 'index', 'view')"
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Verzorging"
        route="/care"
        icon="care"
      ></main-navbar-button>
    </div>
    <div class="col-6 col-sm-12">
      <main-navbar-button
        title="Kinderen"
        route="/children"
        icon="child"
      ></main-navbar-button>
    </div>
    <div
      v-if="getApplicationSetting('child_tracking_system') === '1' && isAuthorized('child-tracking-system', 'index', 'view')"
      class="col-6 col-sm-12"
    >
      <main-navbar-button
        title="Kindvolgsysteem"
        route="/childtrackingsystem/analyse"
        icon="childtrackingsystem"
      ></main-navbar-button>
    </div>
    <div
      class="col-6 col-sm-12"
      v-if="this.isGastouderapp() && isAuthorized('gastouder', 'index', 'view')"
    >
      <main-navbar-button
        title="Urenregistratie"
        route="/gastouder/hours-open"
        icon="hours-registration"
      ></main-navbar-button>
    </div>

    <!--        Hamburger menu grid small -->
    <div
      v-if="getApplicationSetting('ipad_employee_present') === '1'"
      class="col-6 d-sm-none"
    >
      <main-navbar-button
        title="Medewerkers"
        route="/employees"
        icon="employee"
        :fontSize="'1.5rem'"
      ></main-navbar-button>
    </div>
    <div class="col-6 d-sm-none">
      <main-navbar-button
        title="Andere groep"
        route="/select-group"
        icon="switch"
      ></main-navbar-button>
    </div>
    <div class="col-6 d-sm-none">
      <main-navbar-button
        title="Over"
        route="/about"
        icon="info"
      ></main-navbar-button>
    </div>
    <div class="col-6 d-sm-none">
      <main-navbar-button
        title="Uitloggen"
        route="/logout"
        icon="logout"
      ></main-navbar-button>
    </div>
    <!--        Hamburger menu grid small end-->
  </div>
</template>

<script>
import MainNavbarButton from "@/components/Main-Navbar-Button";

export default {
  name: "main-navbar",
  components: {
    MainNavbarButton,
  },
  data() {
    return {
      interval: null,
      hasNewMessages: false,
    };
  },
  computed: {
    hasUnreadChatMessages() {
      return this.$store.getters.hasUnreadChatMessages;
    },
  },
  created() {
    this.$store.dispatch("updateHasUnreadChatMessages");
    clearInterval(this.interval);
    var app = this;
    this.interval = setInterval(function () {
      app.$store.dispatch("updateHasUnreadChatMessages");
    }, 30000);
  },
  unmounted() {
    clearInterval(this.interval);
  },
  methods: {
    routeUrl() {
      if (this.isAuthorized("administration", "transfer-notes", "view")) {
        return "/transfer/messages";
      } else if (this.isAuthorized("administration", "news", "view")) {
        return "/transfer/news";
      } else if (
        this.isAuthorized("administration", "personal-documents", "view") ||
        this.isAuthorized("gastouder", "qualifications", "view") ||
        this.isAuthorized("gastouder", "documents", "view") ||
        this.isAuthorized("gastouder", "payout-details", "view") ||
        this.isAuthorized("gastouder", "agreements", "view") ||
        this.isAuthorized("gastouder", "correspondence", "view") ||
        this.isAuthorized("gastouder", "benefit-overview", "view") ||
        this.isAuthorized("gastouder", "annual-statement", "view")
      ) {
        return "/transfer/filesPersonal";
      } else if (
        this.isAuthorized("administration", "general-documents", "view")
      ) {
        return "/transfer/filesGeneral";
      } else if (
        this.isAuthorized("administration", "person-register", "view")
      ) {
        return "/transfer/personRegister";
      } else if (
        this.isAuthorized("administration", "employee-planning", "view") ||
        this.isAuthorized("administration", "child-planning-mutations", "view")
      ) {
        return "/transfer/reports";
      } else if (
        this.isAuthorized("administration", "daycareRequest", "view")
      ) {
        return "/transfer/mutationRequests";
      }
    },
    routePhoto() {
      if (!this.isAuthorized("communication", "photos", "add")) {
        return "/photos/browse";
      } else {
        return "/photos";
      }
    },
  },
};
</script>

<style scoped>
* {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

@media (max-width: 577px) {
  .col-6:nth-child(odd) {
    padding-right: 0;
  }

  .col-6:nth-child(even) {
    padding-left: 0;
  }
}
</style>
